import ClientConfig = gapi.auth2.ClientConfig;
import { config } from "@fidget/common/config/config";

export const gapiConfig: ClientConfig = {
  client_id: config.services.googleClientID,
  ux_mode: "popup",
  scope: "https://www.googleapis.com/auth/calendar.readonly",
  fetch_basic_profile: false
};
